var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":_vm.reportPath,"width":"100%","height":"1000px;"}})
}
var staticRenderFns = []

export { render, staticRenderFns }